import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";
const getUser = (id) => {
  return axios.get(API + "company/edit-user/" + id + "/", {
    headers: authHeader(),
  });
};
const getCustomerUser = (id) => {
  return axios.get(API + "company/edit-customeruser/" + id + "/", {
    headers: authHeader(),
  });
};
const editUser = (
  id,
  name,
  title,
  language,
  timezone,
  email,
  work_phone,
  phone,
  user
) => {
  return axios.post(
    API + "company/edit-user/" + id + "/",
    {
      name,
      title,
      language,
      timezone,
      email,
      work_phone,
      phone,
      user,
    },
    { headers: authHeader() }
  );
};

const editCustomerUser = (id, name, last_name, email, phone, user) => {
  return axios.post(
    API + "company/edit-customeruser/" + id + "/",
    {
      name,
      last_name,
      email,
      phone,
      user,
    },
    { headers: authHeader() }
  );
};
const EditUserService = {
  getUser,
  editUser,
  getCustomerUser,
  editCustomerUser,
};
export default EditUserService;
